import React, { useReducer } from "react";
import axios from "axios";
import AdminemailLogsContext from "./adminemailLogsContext";
import AdminEmailLogsReducer from "./adminemailLogsReducer";
import setAuthToken from "../../functions/auth_header";
import ErrorLogger from "../../components/ErrorLogger";

import {
  GET_ENROLLMENT_ENTRIES,
  GET_ENROLLMENT_SITES,
  GET_ENTRIES,
  GET_ENTRIE,
  GET_ENTRIE_UUID,
  CLEAR_ENTRIE,
  UPDATE_ENTRIE,
  DELETE_ENTRIE,
  AGE_FILTER,
  NOTINTEREST_FILTER,
  TRANSFER_FILTER,
  GET_TRANSFER_REGISTRATIONS,
  SEARCH_FILTER,
  CLEAR_AGE_FILTER,
  CLEAR_NOTINTEREST_FILTER,
  CLEAR_TRANSFER_FILTER,
  CLEAR_SEARCH_FILTER,
  SET_LIST_VIEW,
  FILTER_TABLE,
  CLEAR_FILTER_TABLE,
  SET_FORM_MODAL,
  ADD_NOTES,
  GET_INTERESTNOTES,
  FILTER_ENROLLMENT_SITES,
  CLEAR_FILTER_ENROLLMENT_SITES,
  SET_LOADING,
  GET_INTENTRIES_OPTIMIZED,
  SET_LOADING_OPTIMIZED,
} from "../types";
import { getAppUrl, getLocationApiUrl } from "../../functions/getEnv";

const AdminemailLogsState = (props) => {
  const initialState = {
    searchSites: [],
    filteresSearchSites: [],
    entries: [],
    IntntriesOptimized: [],
    entrie: {},
    entriebyuuid: [],
    filteredEntries: [],
    ageFiltered: [],
    NotinterestedFiltered: [],
    searchFiltered: [],
    registrations: [],
    TransferRegistration: [],
    InterestNotes: [],
    filteredInterestNotes: null,
    ageOver: false,
    ageUnder: false,
    listView: true,
    formModal: {
      siteZipSearchModal: false,
      siteFieldSearchModal: false,
      deleteModal: false,
    },
    sortOptions: {
      createdAt: { asc: false, desc: false },
      age: { asc: false, desc: false },
      studentFirstName: { asc: false, desc: false },
      parentRelationship: { asc: false, desc: false },
      primaryEmail: { asc: false, desc: false },
      phone: { asc: false, desc: false },
      learningCenterName: { asc: false, desc: false },
      status: { asc: false, desc: false },
      lastContactDate: { asc: false, desc: false },
      campaign: { asc: false, desc: false },
      permalink: { asc: false, desc: false },

    },
    selectedSite: {},
    loading: true,
    InterestListStatus: {
      notinterested: false,
    },
    appliedFilters: {},
    currentFilters: {
      charterName: null,
      learningCenterName: null,
      status: null,
      age: null,
      searchText: null,
      startDate: null,
      endDate: null,
      allTime: false,
    },
    currentPage: 1,
    searchText: "",
    setSession: "",
    startDate: null,
    endDate: null,
    error: null,
    pageSize: 300,
    totalCount: 0,
    visibleColumns: {
      createdAt: true,
      learningCenterName: true,
      fromEmail: true,
      recipientEmail: true,
      emailType: true,
      relatedRecordId: true,
      errorMessage: true,
      status: true,
      actions: true,
    },
  };


  const [state, dispatch] = useReducer(AdminEmailLogsReducer, initialState);


	const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
	const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);

 
  const getSearchSites = async () => {
    try {
      const res = await axios.get(
        `${locationApiUrl
        /* process.env.NODE_ENV === `production`
          ? `https://llac-locations-api.azurewebsites.net`
          : `http://localhost:7000` */
        }/enrollment-sites`
      );
      dispatch({ type: GET_ENROLLMENT_SITES, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const filterSearchSites = async (text) => {
    try {
      dispatch({ type: FILTER_ENROLLMENT_SITES, payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearfilteredSearchSites = async () => {
    try {
      dispatch({ type: CLEAR_FILTER_ENROLLMENT_SITES });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };


  const setCurrentPage = (page) => {
    dispatch({ type: "SET_CURRENT_PAGE", payload: page });
  };


  const getEntries = async ({
    learningCenterCharter,
    learningCenterName,
    status,
    emailType,
    page = 1,
    pageSize = 300,
    searchText,
    startDate,
    endDate,
    allTime = false
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: SET_LOADING });

      const params = new URLSearchParams();

      // New enrollment-specific filters
      if (learningCenterCharter && learningCenterCharter !== "all") {
        params.append("learningCenterCharter", learningCenterCharter);
      }
      if (learningCenterName && learningCenterName !== "all") {
        params.append("learningCenterName", learningCenterName);
      }

      if (status && status !== "all") {
      
        params.append("status", status);
      }

      if (emailType && emailType !== "all") {
        params.append("emailType", emailType);
      }

      // Search filter
      if (searchText) params.append("search", searchText);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      if (allTime) params.append("allTime", allTime);

      // Pagination
      params.append("page", page);
      params.append("pageSize", pageSize);


      // Perform GET request to enrollment API
      const response = await axios.get(`${appUrl}/api/emailLogs?${params.toString()}`);


      dispatch({
        type: GET_ENROLLMENT_ENTRIES, // You may need to create this action type
        payload: response.data.data,
        totalCount: response.data.total_count,
        appliedFilters: response.data.applied_filters,
        learningCenterCharter,
        learningCenterName,
        status,
        emailType,
        page,
        pageSize,
        searchText,
        startDate,
        endDate,
        allTime
      });
    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };

   const getIntEntriesOptimize = async ({
    learningCenterCharter,
    learningCenterName,
    status,
    emailType,
    searchText,
    startDate,
    endDate,
  } = {}) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      dispatch({ type: SET_LOADING_OPTIMIZED });

      const params = new URLSearchParams();
      if (learningCenterCharter && learningCenterCharter !== "all") {
        params.append("learningCenterCharter", learningCenterCharter);
      }
      if (learningCenterName && learningCenterName !== "all") {
        params.append("learningCenterName", learningCenterName);
      }

      if (status && status !== "all") {
        params.append("status", status);
      }

      if (emailType && emailType !== "all") {
        params.append("emailType", emailType);
      }

      // Search filter
      if (searchText) params.append("search", searchText);

      // Date range filters
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const response = await axios.get(`${appUrl}/api/optimizeEmailAPI?${params.toString()}`);



      dispatch({
        type: GET_INTENTRIES_OPTIMIZED,
        payload: response.data.data, // only filtered data is sent
        learningCenterCharter,
        learningCenterName,
        status,
        emailType,
        searchText,
        startDate,
        endDate,
      });
      return response.data.data;
    } catch (error) {
      ErrorLogger.logError(error.message);
    }
  };
  
  const getEntrie = async (id) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/emailLogs/${id}`);
      dispatch({ type: GET_ENTRIE, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  // const getEntriebyuuid = async (_uuid) => { 
  //   try {

  //     const authRes = await axios.get(`${appUrl}/auth/webapp`);
  //     const userAccessToken = authRes.data.accessTokens[0];
  //     setAuthToken(userAccessToken);

  //     const response = await axios.get(`${appUrl}/api/enrollment/${_uuid}`);

  //     dispatch({
  //       type: GET_ENTRIE_UUID,
  //       payload: { data: response.data },
  //     });
  //     return response;

  //   } catch (error) {
  //     console.error("Error retrieving data:", error);
  //     ErrorLogger.logError(error.message);
  //   }
  // };
  const updateEntrie = async (id, data) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.put(`${appUrl}/api/emailLogs/${id}`, data);
      dispatch({ type: UPDATE_ENTRIE, payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const deleteEntrie = async (id) => {
    try {
      const res = await axios.delete(`${appUrl}/api/emailLogs/${id}`);
      dispatch({ type: DELETE_ENTRIE, payload: id });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const ageFilter = async (type) => {
    try {
      dispatch({ type: AGE_FILTER, payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const NotInterestFilter = async (type) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: NOTINTEREST_FILTER, payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const TransferRegFilter = async (type) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      dispatch({ type: TRANSFER_FILTER, payload: type });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const searchFilter = async (text) => {
    try {
      dispatch({ type: SEARCH_FILTER, payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearAgeFilter = () => {
    try {
      dispatch({ type: CLEAR_AGE_FILTER });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    } 
  };

  const clearNotinterestFilter = () => {
    try {
      dispatch({ type: CLEAR_NOTINTEREST_FILTER });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearTransfer = () => {
    try {
      dispatch({ type: CLEAR_TRANSFER_FILTER });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearSearchFilter = () => {
    try {
      dispatch({ type: CLEAR_SEARCH_FILTER });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const clearEntrie = async () => {
    try {
      dispatch({ type: CLEAR_ENTRIE });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };
  const setListView = (value) => {
    try {
      dispatch({ type: SET_LIST_VIEW, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const toggleColumn = (columnName) => {
    dispatch({ type: "TOGGLE_COLUMN", payload: columnName });
  };

  const onTableFilter = (value) => {
    try {
      dispatch({ type: FILTER_TABLE, payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const clearTableFilter = () => {
    try {
      dispatch({ type: CLEAR_FILTER_TABLE });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  const setFormModal = (name, value) => {
    try {
      dispatch({ type: SET_FORM_MODAL, payload: { name, value } });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error.message);
    }
  };

  return (
    <AdminemailLogsContext.Provider
      value={{
        searchSites: state.searchSites,
        filteresSearchSites: state.filteresSearchSites,
        entries: state.entries,
        entrie: state.entrie,
        entriebyuuid: state.entriebyuuid,
        filteredEntries: state.filteredEntries,
        ageFiltered: state.ageFiltered,
        NotinterestedFiltered: state.NotinterestedFiltered,
        InterestListStatus: state.InterestListStatus,
        registrations: state.registrations,
        TransferRegistration: state.TransferRegistration,
        searchFiltered: state.searchFiltered,
        ageOver: state.ageOver,
        ageUnder: state.ageUnder,
        listView: state.listView,
        visibleColumns: state.visibleColumns,
        sortOptions: state.sortOptions,
        formModal: state.formModal,
        loading: state.loading,
        filteredInterestNotes: state.filteredInterestNotes,
        InterestNotes: state.InterestNotes,
        totalCount: state.totalCount,
        appliedFilters: state.appliedFilters,
        pagination: state.pagination,
        currentFilters: state.currentFilters,
        currentPage: state.currentPage,
        setSession: state.setSession,
        pageSize: state.pageSize,
        IntntriesOptimized:state.IntntriesOptimized,
        loadingOpt: state.loadingOpt,
        getEntries,
        getEntrie,
      //  getEntriebyuuid,
        //gettransferRegistrations,
        TransferRegFilter,
        //addNotes,
       // getNotes,
        clearEntrie,
        updateEntrie,
        deleteEntrie,
        //updateEnrollmentStatus,
        ageFilter,
        NotInterestFilter,
        searchFilter,
        clearAgeFilter,
        clearNotinterestFilter,
        clearTransfer,
        clearSearchFilter,
        setListView,
        toggleColumn,
        onTableFilter,
        clearTableFilter,
        setFormModal,
        getSearchSites,
        filterSearchSites,
        clearfilteredSearchSites,
        setCurrentPage,
        getIntEntriesOptimize,
        
      }}
    >
      {props.children}
    </AdminemailLogsContext.Provider>
  );
};

export default AdminemailLogsState;
